module.exports = __webpack_public_path__ + "img/sort -none.f72f2e5d.svg";